export default __webpack_public_path__ + "static/courses-bottom-background-486e626cc048363ac97af8f2fa88cab9.jpg";